export const VerificationCenter_API = {
  calendar: { getCalendar, deleteCalendarItem, updateCalendarItem, addCalendarItem },
  allPatients: { getPatient, updatePatient, getPatientQuiz, updatePatientQuiz, getListOfStudyTypes },
  activities: {
    assistants: {
      getAssistants,
      getAssistant,
      updateAssistant,
      deleteAssistant,
      addAssistant
    }
  },
  errors: {
    carSurvey: {
      getAllCarSurveys,
      getOrganizationCarSurveys,
      updateCarSurveyPatient,
      carSurveyPdfGeneration,
      carSurveyRegistryGeneration,
	  getAllCarSurveysToday,
	  setCarSurveyToday
    },
    cabinetSurvey: { 
	  getAllCabinetSurveys, 
	  getAllOrganizationCabinetSurveys, 
	  updateCabinetSurveyPatient 
    },
   
  },
  doctor: {getDiagnosesMismatch, getErrors,getDoctors,saveDoctor, getListOfStudyTypes}
}
//Doctor
function getDoctors(userId) {
  return {api: `/api/v2/verificationCenters/${userId}/doctors?`, method: 'GET'}
}
function saveDoctor(userId,id) {
  return {api: `/api/v2/verificationCenters/${userId}/doctors/${id}/save`, method: 'POST'}
}


function getDiagnosesMismatch(userId){
  return {api: `/api/v2/verificationCenters/${userId}/studies/mismatch?`, method: 'GET'}
}
function getErrors(userId){
  return {api: `/api/v2/verificationCenters/${userId}/studies/mismatch?`, method: 'GET'}
}


//allPatients
function getPatient(userId, patientId, resultId) {
  return { api: `/api/v2/verificationCenters/${userId}/patients/${patientId}/results/${resultId}`, method: 'GET' }
}

function updatePatient(userId, patientId, resultId) {
  return { api: `/api/v2/verificationCenters/${userId}/patients/${patientId}/results/${resultId}`, method: 'PUT' }
}

//Activities
//roles
function getAssistants(userId) {
  return { api: `/api/v2/verificationCenters/${userId}/employees?`, method: 'GET' }
}

function getAssistant(userId,assistantId) {
  return { api: `/api/v2/verificationCenters/${userId}/employees/${assistantId}`, method: 'GET' }
}

function addAssistant(userId) {
  return { api: `/api/v2/verificationCenters/${userId}/employees`, method: 'POST' }
}

function updateAssistant(userId, assistantId) {
  return { api: `/api/v2/verificationCenters/${userId}/employees/${assistantId}`, method: 'PUT' }
}

function deleteAssistant(userId,assistantId) {
  return { api: `/api/v2/verificationCenters/${userId}/employees/${assistantId}`, method: 'DELETE' }
}


//Errors/car survey
function getAllCarSurveys(userId) {
  return { api: `/api/v2/verificationCenters/${userId}/histories?`, method: 'GET' }
}

function getOrganizationCarSurveys(userId,orgId) {
  return { api: `/api/v2/verificationCenters/${userId}/histories/${orgId}?`, method: 'GET' }
}

function carSurveyPdfGeneration(orgId) {
  return { api: `/api/v1/verificationCenter/study/organizations/${orgId}/results?`, method: 'GET' }
}

function carSurveyRegistryGeneration(orgId) {
  return { api: `/api/v1/verificationCenter/study/organizations/${orgId}/results/registry?`, method: 'GET' }
}

function updateCarSurveyPatient(orgId, patientId) {
  return { api: `/api/v1/verificationCenter/study/organizations/${orgId}/patients/${patientId}`, method: 'PUT' }
}

//Errors/cabinet

function getAllCabinetSurveys(userId) {
  return { api: `/api/v2/verificationCenters/${userId}/cabhistories?`, method: 'GET' }
}


function getAllOrganizationCabinetSurveys(orgId) {
  return { api: `/api/v1/verificationCenter/errors/${orgId}?`, method: 'GET' }
}

function updateCabinetSurveyPatient(orgId, errorId) {
  return { api: `/api/v1/verificationCenter/errors/${orgId}/patients/${errorId}`, method: 'PUT' }
}

//calendar
function getCalendar() {
  return { api: `/api/v1/verificationCenter/calendars?`, method: 'GET' }
}

function deleteCalendarItem(deletedCalendarItemId) {
  return { api: `/api/v1/verificationCenter/calendars/${deletedCalendarItemId}`, method: 'DELETE' }
}

function addCalendarItem() {
  return { api: `/api/v1/verificationCenter/calendars`, method: 'POST' }
}

function updateCalendarItem(updatedCalendarItemId) {
  return { api: `/api/v1/verificationCenter/calendars/${updatedCalendarItemId}`, method: 'PUT' }
}

function getPatientQuiz(userId, patientId, resultId) {
  return { api: `/api/v2/verificationCenters/${userId}/patientquiz/${patientId}/results/${resultId}`, method: 'GET' }
}

function updatePatientQuiz(userId, patientId, resultId) {
  return { api: `/api/v2/verificationCenters/${userId}/patientquiz/${patientId}/results/${resultId}`, method: 'PUT' }
}


function getAllCarSurveysToday(userId) {
  return { api: `/api/v2/verificationCenters/${userId}/historiestoday?`, method: 'GET' }
}
function setCarSurveyToday(userId, studyId, actionId) {
  return { api: `/api/v2/verificationCenters/${userId}/historiessettoday/${studyId}/${actionId}`, method: 'POST' }
}

function getListOfStudyTypes() {
  return { api: `/api/v1/doctors/listOfTypes`, method: 'POST' }
}
